"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Groups;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Groups(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "groups"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M49.99,78.823a3.139,3.139,0,0,0,1.994-.717l9.382-7.9a3.439,3.439,0,0,0,1.172-3.189L56.326,34.328a12.249,12.249,0,0,0,.668-1.035c1.725-2.987,1.933-6.052.572-8.408S53.448,21.179,50,21.179s-6.208,1.351-7.567,3.707-1.152,5.42.573,8.407c.209.363.432.7.664,1.029L37.452,67.061A3.413,3.413,0,0,0,38.6,70.179l9.44,7.948A3.065,3.065,0,0,0,49.99,78.823ZM46.763,27.386c.435-.756,1.646-1.207,3.237-1.207s2.8.451,3.237,1.207.222,2.03-.573,3.407-1.792,2.2-2.665,2.2-1.868-.823-2.663-2.2h0C46.54,29.416,46.326,28.142,46.763,27.386Zm1.353,10.321A6.538,6.538,0,0,0,50,37.994h0a6.544,6.544,0,0,0,1.879-.286l5.562,29.267L50,73.242l-7.442-6.266Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M90,47.5A2.5,2.5,0,0,0,87.5,50,37.542,37.542,0,0,1,50,87.5a2.5,2.5,0,0,0,0,5A42.548,42.548,0,0,0,92.5,50,2.5,2.5,0,0,0,90,47.5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M52.5,10A2.5,2.5,0,0,0,50,7.5,42.548,42.548,0,0,0,7.5,50a2.5,2.5,0,0,0,5,0A37.543,37.543,0,0,1,50,12.5,2.5,2.5,0,0,0,52.5,10Z"
  })))));
}